module.exports = __webpack_public_path__ + "img/bus-1.663002a6.jpg";